<template>
  <div id="app">
    <router-view/>

    <!-- 更新内容提示弹窗 -->
    <div v-show="showUpdateNotification" class="update-notification-overlay" @click.self="closeUpdateNotification">
      <div class="update-notification-dialog">
        <div class="update-header">
          <div class="update-icon">
            <i class="el-icon-star-on"></i>
          </div>
          <h3 class="update-title">功能更新</h3>
          <button class="close-icon" @click="closeUpdateNotification">
            <i class="el-icon-close"></i>
          </button>
        </div>
        <div class="update-content">
          <div class="update-item">
            <div class="update-badge">优化</div>
            <div class="update-text">
              <p>1、优化整体操作界面，精简页面跳转步骤，大幅提升使用效率<br>
2、重构编辑页面布局，内容展示更直观，编辑体验全面升级<br>
3、整合创作入口，将短视频制作与 PPT 视频制作功能合并，无需反复切换<br>
4、功能入口重新规划，我的作品、我的草稿、PPT 生成页面统一移入头像下拉菜单，页面布局更清爽</p>
            </div>
          </div>
        </div>
        <div class="update-footer">
          <button class="update-confirm-btn" @click="closeUpdateNotification">知道了</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      showUpdateNotification: false,
      updateVersion: 'v1.4.0'
    }
  },
  mounted () {
    this.checkUpdateNotification()
  },
  methods: {
    checkUpdateNotification () {
      const viewedVersion = window.localStorage.getItem('viewedUpdateVersion')
      if (viewedVersion !== this.updateVersion) {
        setTimeout(() => {
          this.showUpdateNotification = true
        }, 1000)
      }
    },
    closeUpdateNotification () {
      this.showUpdateNotification = false
      window.localStorage.setItem('viewedUpdateVersion', this.updateVersion)
    }
  }
}
</script>

<style>
  a  {
    text-decoration: none;
    color: #000;
  }
  body  {
    margin: 0;
    box-sizing: border-box;
  }
  * {
    box-sizing: border-box;
  }

  /* 更新提示弹窗样式 */
  .update-notification-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.75);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    backdrop-filter: blur(4px);
    animation: fadeIn 0.3s ease;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .update-notification-dialog {
    background: linear-gradient(135deg, #1e2a52 0%, #2c3e50 100%);
    border-radius: 16px;
    width: 90%;
    max-width: 520px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.6);
    border: 1px solid rgba(255, 255, 255, 0.15);
    animation: slideUp 0.4s ease;
    position: relative;
    overflow: hidden;
  }

  .update-notification-dialog::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #f7b500, #ff6b6b, #409eff, #18e7ca);
    background-size: 300% 100%;
    animation: gradientShift 3s ease infinite;
  }

  @keyframes slideUp {
    from {
      transform: translateY(20px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @keyframes gradientShift {
    0%, 100% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
  }

  .update-header {
    padding: 24px 24px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    position: relative;
  }

  .update-icon {
    position: absolute;
    left: 50%;
    top: -20px;
    transform: translateX(-50%);
    width: 56px;
    height: 56px;
    background: linear-gradient(135deg, #f7b500, #ff9500);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 16px rgba(247, 181, 0, 0.4);
    border: 3px solid #1e2a52;
  }

  .update-icon i {
    font-size: 28px;
    color: #fff;
    animation: starRotate 4s ease-in-out infinite;
  }

  @keyframes starRotate {
    0%, 100% {
      transform: rotate(0deg) scale(1);
    }
    25% {
      transform: rotate(-10deg) scale(1.1);
    }
    75% {
      transform: rotate(10deg) scale(1.1);
    }
  }

  .update-title {
    flex: 1;
    text-align: center;
    font-size: 1.4rem;
    font-weight: 600;
    color: #fff;
    margin: 0;
    padding-top: 20px;
    letter-spacing: 1px;
  }

  .close-icon {
    position: absolute;
    top: 16px;
    right: 16px;
    width: 32px;
    height: 32px;
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .close-icon i {
    font-size: 16px;
    color: #a0a0ff;
  }

  .close-icon:hover {
    background: rgba(255, 255, 255, 0.15);
    transform: rotate(90deg);
  }

  .update-content {
    padding: 24px;
    max-height: 400px;
    overflow-y: auto;
  }

  .update-content::-webkit-scrollbar {
    width: 6px;
  }

  .update-content::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 3px;
  }

  .update-content::-webkit-scrollbar-thumb {
    background: rgba(64, 158, 255, 0.3);
    border-radius: 3px;
  }

  .update-content::-webkit-scrollbar-thumb:hover {
    background: rgba(64, 158, 255, 0.5);
  }

  .update-item {
    display: flex;
    gap: 16px;
    margin-bottom: 20px;
    padding: 16px;
    background: rgba(0, 0, 0, 0.2);
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    transition: all 0.3s ease;
    animation: itemSlideIn 0.5s ease forwards;
    opacity: 0;
  }

  .update-item:nth-child(1) { animation-delay: 0.1s; }
  .update-item:nth-child(2) { animation-delay: 0.2s; }
  .update-item:nth-child(3) { animation-delay: 0.3s; }
  .update-item:nth-child(4) { animation-delay: 0.4s; }

  .update-item:hover {
    background: rgba(0, 0, 0, 0.3);
    border-color: rgba(64, 158, 255, 0.3);
    transform: translateX(4px);
  }

  .update-item:last-child {
    margin-bottom: 0;
  }

  @keyframes itemSlideIn {
    from {
      opacity: 0;
      transform: translateX(-20px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  .update-badge {
    flex-shrink: 0;
    padding: 4px 10px;
    height: fit-content;
    border-radius: 6px;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .update-item:nth-child(1) .update-badge {
    background: linear-gradient(135deg, #ff6b6b, #ff9500);
    color: #fff;
    box-shadow: 0 2px 8px rgba(255, 107, 107, 0.3);
  }

  .update-item:nth-child(2) .update-badge {
    background: linear-gradient(135deg, #409eff, #18e7ca);
    color: #fff;
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
  }

  .update-item:nth-child(3) .update-badge {
    background: linear-gradient(135deg, #a855f7, #6366f1);
    color: #fff;
    box-shadow: 0 2px 8px rgba(168, 85, 247, 0.3);
  }

  .update-item:nth-child(4) .update-badge {
    background: linear-gradient(135deg, #10b981, #059669);
    color: #fff;
    box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
  }

  .update-text {
    flex: 1;
  }

  .update-text h4 {
    margin: 0 0 8px 0;
    font-size: 1.1rem;
    font-weight: 600;
    color: #fff;
    letter-spacing: 0.3px;
  }

  .update-text p {
    margin: 0;
    font-size: 0.9rem;
    line-height: 1.6;
    color: #c0c0ff;
  }

  .update-footer {
    padding: 16px 24px 24px;
    display: flex;
    justify-content: center;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }

  .update-confirm-btn {
    padding: 12px 48px;
    background: linear-gradient(135deg, #409eff, #18e7ca);
    color: #fff;
    border: none;
    border-radius: 8px;
    font-size: 1rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
  }

  .update-confirm-btn::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.2);
    transform: translate(-50%, -50%);
    transition: width 0.6s, height 0.6s;
  }

  .update-confirm-btn:active::before {
    width: 300px;
    height: 300px;
  }

  .update-confirm-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(64, 158, 255, 0.5);
    filter: brightness(1.1);
  }

  @media (max-width: 768px) {
    .update-title {
      font-size: 1.2rem;
    }

    .update-text h4 {
      font-size: 1rem;
    }

    .update-text p {
      font-size: 0.85rem;
    }
  }
</style>
